import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=7e50a68a"
import script from "./TaskForm.vue?vue&type=script&lang=js"
export * from "./TaskForm.vue?vue&type=script&lang=js"
import style0 from "./TaskForm.vue?vue&type=style&index=0&id=7e50a68a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports